<template>
  <div>
    <nav-breadcrumb :menu="[{label: '角色权限'}]"/>
    <el-row>
        <el-col class="grid-content bg-purple xzpadd10" @tab-click="handleClick">
            <el-row>
                <el-tabs v-model="roleType">
                    <el-tab-pane label="金融机构" name="Merchant"></el-tab-pane>
                    <!--<el-tab-pane label="客户角色权限" name="Customer"></el-tab-pane>-->
                    <!--<el-tab-pane label="供应商角色权限" name="Supplier"></el-tab-pane>-->
                </el-tabs>
            </el-row>
            <el-row class="xzpadd105">
                <!--<el-col>-->
                    <!--<el-row>-->
                        <!--<el-col>-->
                            <!--<el-collapse-transition>-->
                                <!--<div v-show="multipleSelection.length>0">-->
                                    <!--<el-row>-->
                                        <!--<el-col>-->
                                            <!--<div>-->
                                                <!--<ul class="toolbar">-->
                                                <!--<li>已选中 {{multipleSelection.length}}  项</li>-->
                                                <!--<li><a href="#" class="el-icon-delete" @click.prevent="deleteRoles">删除</a></li>-->
                                                <!--</ul>-->
                                            <!--</div>-->
                                        <!--</el-col>-->
                                    <!--</el-row>-->
                                <!--</div>-->
                            <!--</el-collapse-transition>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row>-->
                        <!--<el-col><div class="grid-content bg-purple">-->
                            <!--<el-table :data="roleList.data" style="width: 100%" border @selection-change="handleSelectionChange">-->
                                <!--<el-table-column align="center" type="selection" width="50">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column label="角色名" align="center" width="180"  prop="r__roleName">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column label="分配用户" align="center">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column label="状态" align="center" width="100" prop="r__disabled" :formatter="disabled2CN">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column label="操作" align="center" width="150">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<el-button-group>-->
                                            <!--<router-link :to="'edit?roleId='+scope.row.r__roleId+'&roleType='+scope.row.r__roleType" title="编辑该角色菜单">-->
                                                <!--<i class="el-icon-edit"></i>-->
                                            <!--</router-link>-->
                                            <!--<router-link :to="'functionedit?roleId='+scope.row.r__roleId+'&roleType='+scope.row.r__roleType" title="编辑该角色功能">-->
                                                <!--<i class="el-icon-share"></i>-->
                                            <!--</router-link>-->
                                            <!--<a href="" @click.prevent="deleteRole(scope.row.r__roleId)" title="删除该角色"><i class="el-icon-delete"></i></a>-->
                                        <!--</el-button-group>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                            <!--</el-table>-->

                        <!--</div>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row>-->
                        <!--<el-col>-->
                            <!--<pagination :total="roleList.count" :pageSize="pageSize" :handleCurrentChange="handleCurrentChange"/>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                <!--</el-col>-->
              <el-col>
                <data-table-component
                  :table-data="roleList"
                  :columns="columns"
                  :page.sync="page"
                  :page-size.sync="pageSize"
                  :filters="filters"
                  :actions="actions"
                />
              </el-col>
            </el-row>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import xhr from '@/utils/xhr'
import Pagination from '@/components/Pagination'
import DataTableComponent from "../../../components/DataTable";
import Status2CN from "../../../filters/Status2CN";
import {removeItem} from "../../../filters/CommonActions";
import {xmlBuildQuery} from "../../../filters/CommonActions";

export default {
    data: function() {
      return {
        page: 1,
        pageSize: 20,
        roleType: 'Merchant',
        roleList: {},
        multipleSelection: {},
        columns: [
          {
            label: '角色名',
            field: 'r__roleName'
          },
          // {
          //   label: '分配用户'
          // },
          {
            label: '状态',
            field: 'r__disabled',
            formatter: function (r, c, v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作',
            opts: [
              {
                label: '配置该角色菜单',
                class: 'el-icon-edit',
                clickHandler: (idx, row) => {
                  this.$router.push({
                    path: 'edit',
                    query: {
                      roleId: row.r__roleId,
                      roleType: row.r__roleType
                    }
                  })
                }
              },
              {
                label: '配置该角色功能',
                class: 'el-icon-share',
                clickHandler: (idx, row) => {
                  this.$router.push({
                    path: 'functionedit',
                    query: {
                      roleId: row.r__roleId,
                      roleType: row.r__roleType
                    }
                  })
                }
              },
              {
                label: '删除该角色',
                class: 'el-icon-delete',
                clickHandler: (idx, row) => {
                  this.deleteRole(row.r__roleId)
                }
              }
            ]
          }
        ],
        filters: {
          form: {
            'r__roleName' : ''
          },
          columns: [
            {
              label: '角色名',
              component: 'el-input',
              field: 'r__roleName'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getRoleList()
          }
        },
        actions: [
          {
            label: '新增角色',
            // class: 'el-icon-plus',
            type: 'primary',
            clickHandler: ()=>{
              this.handleNewRole()
            }
          }
        ]
      }
    },
  computed: {

    filterOptions() {
      return {
        pageSize: this.pageSize,
        pageOffset: (this.page-1) * this.pageSize
      }
    }
  },
    watch: {
        roleType: function(val) {
            this.filterOptions = {
                'xlist.search.r.roleType': val,
                'xlist.search.r.roleType.op': 'eq'
            }
            this.getRoleList()
        },
        filterOptions:function () {
          this.getRoleList()
        }
    },
    mounted: function() {
        this.getRoleList()
    },
    components: {
      DataTableComponent,
        Pagination
    },
    methods: {
        disabled2CN: function(row,column,value) {
            return value == 'N' ? '启用' : '禁用'

        },
        handleCurrentChange: function(val) {
            this.page = val
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleSearch: function() {
            this.getRoleList()
        },
        getRoleList: function() {
            xhr.getRoleList(Object.assign(this.filterOptions,{},xmlBuildQuery(this.filters)), res=>{
                this.roleList = res.data
            })
        },
        handleSelectionChange: function(val) {
            this.multipleSelection = val
        },
        //新增角色
        handleNewRole: function(idx) {
            let that = this
            this.$prompt('请输入新的角色名称！', '新增角色', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--primary',
                inputPattern: /.{2}/,
                inputErrorMessage: '角色名称长度不低于2位'
            }).then(({ value }) => {
                xhr.updateRole({
                    'r.roleName': value,
                    'r.checked': true,
                    'r.roleType': that.roleType,
                    'r.disabled': 'N'

                }, function(res) {
                    if(res.data.status == 'success') {
                        that.$message({
                            type: 'success',
                            message: '新增角色成功，角色名称： ' + value
                        });
                    }
                    else {
                        that.$message({
                            type: 'info',
                            message: '新增角色失败！'
                        });
                    }
                    that.getRoleList()
                })
            }).catch(() => {
                that.$message({
                    type: 'info',
                    message: '取消操作'
                });
            });

        },
        //删除
        deleteRole: function(roles) {
          removeItem(
            xhr.deleteRole,
            {
              roles
            },
            res=>{
              try {
                if(res.data.status == 'success') {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  this.getRoleList()
                }
              }catch (e) {

              }
            }
          )
/*
            let that = this
            this.$confirm('此操作将永久删除选中的角色, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                xhr.deleteRole({roles}, res=>{
                    that.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                })
                that.getRoleList()
            }).catch(() => {
                that.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });*/
        },
        //批量删除
        deleteRoles: function() {
            let roles = this.multipleSelection.map(item=> item['r__roleId'])
            this.deleteRole(roles)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigRoleList.vue